import React from "react";
import { useTranslation } from "react-i18next";
import { ICellRendererParams } from "@ag-grid-community/core";

import { Transfer } from "../../../../types";

import { formatTransactionNumber } from "../../../../helpers/format";
import { TwoLineGridCell } from "../../../TransactionsDataGrid/renderers";
import { InvoiceLink } from "../../..";

interface Props extends ICellRendererParams {
  data: Transfer;
}

const TransfersNumberRenderer = ({ data }: Props) => {
  const { t } = useTranslation();
  const secondLineData = (
    <InvoiceLink
      invoiceNumber={data.invoiceNumber}
      prefix={t("invoices.linkPrefixShort")}
    />
  );

  return (
    <TwoLineGridCell
      firstLineData={formatTransactionNumber(data.transferNumber)}
      secondLineData={secondLineData}
    />
  );
};

export default TransfersNumberRenderer;
